// extracted by mini-css-extract-plugin
module.exports = {"rulesContainer":"auditlog_rulesContainer__1m52t","active":"auditlog_active__4a6Zu"};